import React from 'react';

export type ThingProps = React.PropsWithChildren<{
  label: string,
}>;

export const Thing = (props: ThingProps): JSX.Element => {
  return (
    <>{props.children}</>
  );
};

export type ThingSwitcherProps = React.PropsWithChildren<{
  thing: string,
}>;

/* NOTE:
 * Typescript is not happy about what we're doing here, and to be honest it has
 * a small point.  We're leveraging some fields in React that are necessary to do
 * what we're doing, but technically they are not "documented" and they are subject
 * to change.  If that happens we'll deal with it, but currently that's the only
 * way we can do this.  Specifically this applies to child.type.
 */
export const ThingSwitcher = (props: ThingSwitcherProps): JSX.Element | undefined => {
  return (
    <>
      {React.Children.map(props.children, (child) => (
        (typeof(child) == 'object') && child?.type === Thing)
        ? child
        : null
      )
        ?.find((child) => (typeof(child) == 'object') && child?.props?.label === props.thing)}
    </>
  );
};
